import { updateOrCreateResource } from "infrastructure/api";
import { ApiRoutes } from "consts/enpoints/api";
import { BooleanSwitchValue, DateTimeFormatRepository } from "consts/general";
import { useSimpleRequest } from "hooks";
import useUser from "features/auth/useUser";
import { UboIdentity, WithUser } from "features/ecommerce/types";
import { Merchant } from "ui/forms/ECommerce";
import useIdentityFileUpload from "./useIdentityFileUpload";

export const useUpdateOrCreateIdentities = () => {
    const { user } = useUser();

    const request = useSimpleRequest();

    const { handleIdentityFileUpload } = useIdentityFileUpload();

    const handleUpdateOrCreateIdentities = (uboIdentities: Array<Merchant.UBOIdentityVerification.Identity>) => (
        Promise.all(
            uboIdentities.map(uboIdentity => {
                const {
                    pki,
                    fullName,
                    residentialAddress,
                    nationality,
                    dateOfBirth,
                    legalForm
                } = uboIdentity;

                return request<UboIdentity>(() => updateOrCreateResource<WithUser & UboIdentity>({
                    getRoute: () => ApiRoutes.PutOnboardingsUboIdentities(user.coreId, pki),
                    getId: () => pki,
                    body: {
                        userId: user.coreId,
                        fullName,
                        residentialAddress,
                        nationality: [nationality]
                            .filter(Boolean)
                            .join(','),
                        dateOfBirth: dateOfBirth?.format(DateTimeFormatRepository.Default),
                        legalForm,
                        requestedChangeFields: null,
                        isIncomplete: BooleanSwitchValue.Off
                    }
                }), {
                    onError: response => {
                        throw response;
                    },
                    onSuccess: handleIdentityFileUpload(uboIdentity)
                })
            })
        )
    );

    return {
        handleUpdateOrCreateIdentities
    };
};

export default useUpdateOrCreateIdentities;
